import React, { useEffect, useState } from "react";
import moment from "moment";
import { Grid, Typography, Link } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import PeopleIcon from "@material-ui/icons/People";
import Aux from "../../../hoc/Auxilliary";
import {
  getOpportunities,
  clearErrorMessage,
  clearErrorStatusCode,
} from "../../../reduxSlices/alumniSlice";
import MessageIndicator from "../../SnackBar";
import { isObjectEmpty } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import Backdrop from "../../Backdrop";
import "./style.css";
const Opportunities = (props) => {
  const dispatch = useDispatch();
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const opportunities = useSelector((state) => state.alumniData.opportunities);
  const errorMessage = useSelector((state) => state.alumniData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.alumniData.errorStatusCode,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.alumniData.dataFetchingStatus,
  );
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);
  useEffect(() => {
    dispatch(getOpportunities());
  }, []);
  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };
  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={error.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <div className="opportunity">
        <Grid container direction="column">
          <Grid item>
            <Typography variant="h6">Opportunities</Typography>
          </Grid>
          {opportunities.map((opportunity, index) => {
            return (
              <Grid item key={index}>
                <div className="opportunity__card">
                  <div className="opportunity__card-title">
                    <Typography>
                      {opportunity.ses_job} - {opportunity.ses_position}
                    </Typography>
                  </div>
                  <div style={{ padding: "12px 15px" }}>
                    <Grid item container justify="space-between">
                      <Grid xs={9} item>
                        <Grid container direction="column">
                          <Grid item>
                            <Typography>{opportunity.ses_industry}</Typography>
                          </Grid>
                          <Grid item>
                            <Typography>{opportunity.ses_company}</Typography>
                          </Grid>
                          <Grid item style={{ textTransform: "capitalize" }}>
                            <Typography>
                              {opportunity.ses_requirements}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid xs={3} item>
                        <Grid container direction="column">
                          <Grid item>
                            <Typography>
                              Posted:{" "}
                              {opportunity.ses_dateposted
                                ? moment(opportunity.ses_dateposted).format(
                                    "DD/MM/YYYY",
                                  )
                                : ""}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography style={{ display: "flex" }}>
                              <PeopleIcon />{" "}
                              {opportunity.ses_email ? (
                                <Link href={`mailto:${opportunity.ses_email}`}>
                                  <span style={{ marginLeft: "5px" }}>
                                    {" "}
                                    {opportunity.ses_contact}
                                  </span>
                                </Link>
                              ) : (
                                <span style={{ marginLeft: "5px" }}>
                                  {" "}
                                  {opportunity.ses_contact}
                                </span>
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </Aux>
  );
};

export default Opportunities;
